var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isSameDay, isSameMonth } from 'date-fns';
import { AwsUi } from '../../../../core/runtime/src';
import BemClassBuilder from '../../../../core/utils/src/class-builders/bem';
import { renderDayLabel } from './utils/intl';
export default (function (_a) {
    var locale = _a.locale, baseDate = _a.baseDate, date = _a.date, selectedDate = _a.selectedDate, focusedDate = _a.focusedDate, isDateEnabled = _a.isDateEnabled, todayLabel = _a.todayLabel, onSelectDate = _a.onSelectDate, onMouseDown = _a.onMouseDown;
    var labels = [renderDayLabel(locale, date)];
    var isFocusable = isSameDay(date, focusedDate);
    var isSelected = !!selectedDate && isSameDay(date, selectedDate);
    var isEnabled = !isDateEnabled || isDateEnabled(date);
    var classBuilder = new BemClassBuilder({ __componentName: 'awsui-calendar' }, 'date');
    classBuilder.modifier('current-month', isSameMonth(date, baseDate));
    classBuilder.modifier('focusable', isFocusable);
    classBuilder.modifier('enabled', isEnabled);
    var args = {};
    if (isSelected) {
        classBuilder.modifier('selected');
        args['aria-current'] = 'date';
    }
    if (isSameDay(date, new Date())) {
        classBuilder.modifier('today');
        labels.push(todayLabel);
    }
    if (isEnabled) {
        args.onmousedown = function () { return onMouseDown(date); };
        args.onclick = function () { return onSelectDate(date); };
        args.tabindex = -1;
    }
    if (isFocusable) {
        args.tabindex = 0;
    }
    return (AwsUi.__createElement("div", __assign({ className: classBuilder.toString(), "aria-label": labels.join('. '), role: "button" }, args),
        AwsUi.__createElement("span", null, date.getDate())));
});
//# sourceMappingURL=grid-date.js.map